import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import { ReactComponent as AddIcon } from '@/shared/assets/icons-2.0/add.svg';

import type { ExpertDataFormProps } from '../ExpertDataForm';
import { ActiveSubstanceItem } from './ActiveSubstanceItem';

type ActiveSubstancesFieldsProps = {
  drug: ExpertDataFormProps['drug'];
};

export const emptyActiveSubstance = { dosage: null, measure_unit: null, inn: null };

export const ActiveSubstancesFields = (props: ActiveSubstancesFieldsProps) => {
  const { drug } = props;
  const { t } = useTranslation('nomenclature-page');
  const { control } = useFormContext();

  const { fields, append, remove, update } = useFieldArray({ control, name: 'activeSubstances' });

  if (!drug) {
    return null;
  }

  const handleAddActiveSubstance = () => {
    append(emptyActiveSubstance);
  };

  const handleRemoveClick = (index: number) => {
    if (fields.length > 1) {
      remove(index);
    } else {
      update(index, emptyActiveSubstance);
    }
  };

  return (
    <Fragment>
      {fields.map((field, index) => (
        <ActiveSubstanceItem
          isRequired={index > 0 || fields.length > 1}
          key={field.id}
          index={index}
          onRemoveClick={() => handleRemoveClick(index)}
          releaseFormId={drug.release_form_id}
        />
      ))}

      <Grid xs="auto" mt={3} paddingY={0}>
        <Button variant="outlined" onClick={handleAddActiveSubstance} startIcon={<AddIcon />} color="secondary">
          {t('modals.form.ui.expert-data.add-substance')}
        </Button>
      </Grid>
    </Fragment>
  );
};
